import React from 'react';
import ErrorNoReportData from 'components/Pages/Reports/ErrorStates/ErrorNoReportData.jsx';
import ErrorGeneral from 'components/Pages/Reports/ErrorStates/ErrorGeneral.jsx';
import ErrorNoPartnership from 'components/Pages/Reports/ErrorStates/ErrorNoPartnership.jsx';

/* TODO: Figure out - onClick for data retry */
const ReportErrorTab = ({ error, request }) => (
  <React.Fragment>
    { error.type === 'empty_data' ? (
      <ErrorNoReportData error={error} />
    ) : null}

    { error.type === 'empty_partnership' ? (
      <ErrorNoPartnership error={error} request={request} />
    ) : null}

    { error.type === 'error' ? (
      <ErrorGeneral error={error} />
    ) : null}
  </React.Fragment>
);

export default ReportErrorTab;
